import React, { useEffect, useState } from "react";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import Swal from "sweetalert2";

const ActiveSwitchFile = ({ item, record, index, handleUpdate, module }) => {
  const [, dispatch] = useDataLayerValue();
  const [isChecked, setIsChecked] = useState(item === 1);

  useEffect(() => {
    if (record.id) {
      setIsChecked(item === 1);
      if (new Date(record.valid_to) < new Date(new Date()) && item) {
        handleUpdate(
          record.id,
          { is_active: 0 },
          record.title || record.name || record.currency,
          record.location_id,
          record
        );
        setIsChecked(false);
      }
    }
  }, [record]);

  const handleToggle = (e) => {
    const newChecked = e.target.checked;

    try {
      if (new Date(record.valid_to) < new Date()) {
        throw new Error(`${module || "Banner"} is expired`);
      }

      setIsChecked(newChecked); // Update local state immediately
      handleUpdate(
        record.id,
        { is_active: newChecked ? 1 : 0 },
        record.title || record.name || record.currency,
        record.location_id,
        record
      );
    } catch (error) {
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message || "Unknown error occurred",
      });

      // Reset toggle if an error occurred
      setIsChecked(!newChecked);
    }
  };

  return (
    <div key={index + record.id} className="custom-control custom-switch">
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleToggle}
        className="custom-control-input"
        id={`customSwitch1${index}${record.id}`}
      />
      <label
        className="custom-control-label"
        htmlFor={`customSwitch1${index}${record.id}`}
      ></label>
    </div>
  );
};

export default ActiveSwitchFile;
